// GetHeader returns the header of the story page
export const StoryPageService_GetHeaderLazy = () =>
  import("./service.grpc").then((m) => m.StoryPageService_GetHeader);
StoryPageService_GetHeaderLazy.method =
  "aysa_api.services.story_page.v1.StoryPageService/GetHeader" as const;

// GetPage returns the content of the story page
export const StoryPageService_GetPageLazy = () =>
  import("./service.grpc").then((m) => m.StoryPageService_GetPage);
StoryPageService_GetPageLazy.method =
  "aysa_api.services.story_page.v1.StoryPageService/GetPage" as const;

// GetPageNext returns the next page of the story page
export const StoryPageService_GetPageNextLazy = () =>
  import("./service.grpc").then((m) => m.StoryPageService_GetPageNext);
StoryPageService_GetPageNextLazy.method =
  "aysa_api.services.story_page.v1.StoryPageService/GetPageNext" as const;

// GetFilters returns the filter sections which should be shown for the story page stream
export const StoryPageService_GetFiltersLazy = () =>
  import("./service.grpc").then((m) => m.StoryPageService_GetFilters);
StoryPageService_GetFiltersLazy.method =
  "aysa_api.services.story_page.v1.StoryPageService/GetFilters" as const;

// GetCategoryTreeNavigation returns the category tree navigation of the story page stream (for Web Desktop)
export const StoryPageService_GetCategoryTreeNavigationLazy = () =>
  import("./service.grpc").then(
    (m) => m.StoryPageService_GetCategoryTreeNavigation
  );
StoryPageService_GetCategoryTreeNavigationLazy.method =
  "aysa_api.services.story_page.v1.StoryPageService/GetCategoryTreeNavigation" as const;

// GetNavigation returns the navigation section: categories label and popular filters (for App and mWeb[still WIP])
export const StoryPageService_GetNavigationLazy = () =>
  import("./service.grpc").then((m) => m.StoryPageService_GetNavigation);
StoryPageService_GetNavigationLazy.method =
  "aysa_api.services.story_page.v1.StoryPageService/GetNavigation" as const;

// GetNavigationHeader returns the navigation header of the story page mWeb
export const StoryPageService_GetNavigationHeaderLazy = () =>
  import("./service.grpc").then((m) => m.StoryPageService_GetNavigationHeader);
StoryPageService_GetNavigationHeaderLazy.method =
  "aysa_api.services.story_page.v1.StoryPageService/GetNavigationHeader" as const;

// GetNavigationSectionCategories returns the full category tree for the selected story
export const StoryPageService_GetNavigationSectionCategoriesLazy = () =>
  import("./service.grpc").then(
    (m) => m.StoryPageService_GetNavigationSectionCategories
  );
StoryPageService_GetNavigationSectionCategoriesLazy.method =
  "aysa_api.services.story_page.v1.StoryPageService/GetNavigationSectionCategories" as const;

// Metadata [Web only]
export const StoryPageService_MetadataLazy = () =>
  import("./service.grpc").then((m) => m.StoryPageService_Metadata);
StoryPageService_MetadataLazy.method =
  "aysa_api.services.story_page.v1.StoryPageService/Metadata" as const;
